import SEO from "@/components/common/SEO";
import LegalLayout from "./LegalLayout";

import {
  organizationSchema,
  breadcrumbSchema,
} from "../../components/common/schema";

const schemas = [
  organizationSchema(),

  breadcrumbSchema([
    {
      name: "Home",
      path: "/",
    },
    {
      name: "Terms & Conditions",
      path: "/terms-and-conditions",
    },
  ]),
];

export default function TermsAndConditions() {
  return (
    <>
      <SEO
        title="Terms & Conditions"
        description="Read the terms and conditions governing the use of Money Mart's website and loan advisory services."
        canonical="/terms-and-conditions"
        structuredData={schemas}
      />
      <LegalLayout
        title="Terms & Conditions"
        description="These Terms & Conditions govern your access to and use of the Money Mart website and loan advisory services."
        lastUpdated="24 July 2026"
      >
        <h2>1. Acceptance of Terms</h2>

        <p>
          By accessing or using the Money Mart website, submitting an enquiry,
          uploading documents, or using any of our services, you agree to be
          legally bound by these Terms & Conditions. If you do not agree with
          any part of these Terms, you should discontinue using our website and
          services immediately.
        </p>

        <br />

        <h2>2. About Money Mart</h2>

        <p>
          Money Mart is a loan advisory and Bank Channel Partner (DSA) that
          assists customers in identifying suitable loan products offered by
          RBI-regulated Banks and NBFCs.
        </p>

        <p>
          Money Mart does not provide loans directly, does not accept deposits,
          and is not a financial institution or lender.
        </p>

        <br />

        <h2>3. Eligibility</h2>

        <p>By using our website, you represent that:</p>

        <ul>
          <li>You are at least 18 years of age.</li>
          <li>You are legally capable of entering into binding agreements.</li>
          <li>The information provided by you is accurate and complete.</li>
          <li>You will update your information whenever required.</li>
        </ul>

        <br />

        <h2>4. Loan Advisory Services</h2>

        <p>
          Money Mart assists customers by understanding their requirements,
          collecting documentation, evaluating eligibility, and coordinating
          with lending institutions during the loan application process.
        </p>

        <p>
          Final decisions regarding loan approval, interest rates, processing
          fees, repayment tenure, documentation requirements, and disbursement
          are made solely by the respective Bank or NBFC.
        </p>

        <br />

        <h2>5. No Guarantee of Approval</h2>

        <p>
          Submission of an enquiry or loan application through Money Mart does
          not guarantee approval, sanction, disbursement, or any specific loan
          amount.
        </p>

        <p>
          Loan approval depends entirely upon the credit policies, verification
          process, eligibility criteria, and risk assessment conducted by the
          lending institution.
        </p>

        <br />

        <h2>6. User Responsibilities</h2>

        <p>You agree to:</p>

        <ul>
          <li>Provide genuine and accurate information.</li>
          <li>Submit authentic documents only.</li>
          <li>Respond promptly to verification requests.</li>
          <li>Maintain confidentiality of your account information.</li>
          <li>Comply with applicable laws and regulations.</li>
        </ul>

        <p>You shall not:</p>

        <ul>
          <li>Submit false or misleading information.</li>
          <li>Use another person's identity or documents.</li>
          <li>Attempt unauthorized access to our systems.</li>
          <li>Upload malicious software or harmful content.</li>
          <li>Interfere with the functioning of our website.</li>
        </ul>

        <br />

        <h2>7. Document Verification</h2>

        <p>
          You authorize Money Mart to collect, verify, process, and share your
          documents with relevant Banks, NBFCs, verification agencies, and
          technology partners solely for processing your loan application.
        </p>

        <br />

        <h2>8. Communication Consent</h2>

        <p>
          By submitting your enquiry, you authorize Money Mart to contact you
          via telephone, SMS, WhatsApp, email, or other communication channels
          regarding:
        </p>

        <ul>
          <li>Loan enquiries.</li>
          <li>Application updates.</li>
          <li>Documentation requests.</li>
          <li>Verification activities.</li>
          <li>Promotional offers related to financial products.</li>
        </ul>

        <p>
          Such communication may continue until your enquiry or application is
          closed unless otherwise required by law.
        </p>

        <br />

        <h2>9. Intellectual Property</h2>

        <p>
          All website content including text, graphics, branding, logos, design,
          layouts, software, icons, and visual elements are owned by or licensed
          to Money Mart and are protected under applicable intellectual property
          laws.
        </p>

        <p>
          You may not copy, reproduce, modify, distribute, publish, or exploit
          any content without prior written permission.
        </p>

        <br />

        <h2>10. Third-Party Services</h2>

        <p>
          Our website may contain links to third-party websites, banking
          portals, payment gateways, or external services. Money Mart is not
          responsible for the content, policies, availability, or security of
          such third-party platforms.
        </p>

        <br />

        <h2>11. Limitation of Liability</h2>

        <p>
          To the maximum extent permitted by law, Money Mart shall not be liable
          for any direct, indirect, incidental, consequential, special, or
          punitive damages arising from:
        </p>

        <ul>
          <li>Loan rejection.</li>
          <li>Delay in loan processing.</li>
          <li>Technical interruptions.</li>
          <li>Website downtime.</li>
          <li>Errors in information provided by third parties.</li>
          <li>Decisions taken by Banks or NBFCs.</li>
        </ul>

        <br />

        <h2>12. Indemnification</h2>

        <p>
          You agree to indemnify and hold harmless Money Mart, its employees,
          partners, representatives, and affiliates from any claims, losses,
          liabilities, damages, legal proceedings, or expenses arising from:
        </p>

        <ul>
          <li>Your violation of these Terms.</li>
          <li>Submission of false information.</li>
          <li>Misuse of our website.</li>
          <li>Violation of applicable laws.</li>
        </ul>

        <br />

        <h2>13. Suspension of Services</h2>

        <p>
          Money Mart reserves the right to suspend or terminate access to the
          website or its services at any time without prior notice if
          fraudulent, illegal, abusive, or suspicious activity is detected.
        </p>

        <br />

        <h2>14. Privacy</h2>

        <p>
          Your use of this website is also governed by our Privacy Policy, which
          explains how your personal information is collected, processed,
          stored, and shared.
        </p>

        <br />

        <h2>15. Changes to These Terms</h2>

        <p>
          We may modify these Terms & Conditions at any time. Updated versions
          will become effective immediately upon publication on this website.
          Continued use of the website constitutes acceptance of the revised
          Terms.
        </p>

        <br />

        <h2>16. Governing Law</h2>

        <p>
          These Terms & Conditions shall be governed by and interpreted in
          accordance with the laws of India.
        </p>

        <p>
          Any disputes arising from these Terms shall be subject to the
          exclusive jurisdiction of the competent courts of Jodhpur, Rajasthan.
        </p>

        <br />

        <h2>17. Contact Us</h2>

        <p>
          For any questions regarding these Terms & Conditions, please contact
          Money Mart through the contact details provided on our website.
        </p>
      </LegalLayout>
    </>
  );
}
